import { render, staticRenderFns } from "./overview-main-card-table-row.component.vue?vue&type=template&id=32e1e15c&scoped=true&"
import script from "./overview-main-card-table-row.component.vue?vue&type=script&lang=ts&"
export * from "./overview-main-card-table-row.component.vue?vue&type=script&lang=ts&"
import style0 from "./overview-main-card-table-row.component.vue?vue&type=style&index=0&id=32e1e15c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1e15c",
  null
  
)

export default component.exports